module.exports = __webpack_public_path__ + "img/logo-pic.db5a82c1.png";